import './App.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/captions.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';
import 'react-datepicker/dist/react-datepicker.css';

import {BrowserRouter, Route, Routes} from 'react-router-dom';

import Home from "./pages/Home.jsx";
import Menu from "./pages/Menu.jsx";
import Datenschutz from "./pages/Datenschutz.jsx";
import Impressum from "./pages/Impressum.jsx";
import Booking from "./pages/Booking.jsx";
import ScrollToTop from "./components/layout/ScrollTop.js";
import LayoutComponent from "./components/layout/LayoutComponent.jsx";
import ContactPage from "./pages/ContactPage.jsx";


function App() {

    return (
        <BrowserRouter>
            <ScrollToTop>
                <Routes>
                    <Route path="/" element={<LayoutComponent><Home/></LayoutComponent>}/>
                    <Route path="/home" element={<LayoutComponent><Home/></LayoutComponent>}/>
                    <Route path="/menu" element={<LayoutComponent><Menu/></LayoutComponent>}/>
                    <Route path="/booking" element={<LayoutComponent><Booking/></LayoutComponent>}/>
                    <Route path="/kontaktieren-sie-uns" element={<LayoutComponent><ContactPage/></LayoutComponent>}/>
                    <Route path="/Impressum" element={<LayoutComponent><Impressum/></LayoutComponent>}/>
                    <Route path="/Datenschutz" element={<LayoutComponent><Datenschutz/></LayoutComponent>}/>
                </Routes>
            </ScrollToTop>
        </BrowserRouter>

    );
}

export default App;
